"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroupMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Button = require("../../components/Button/Button.styles");
var _IconButton = require("../../components/IconButton/IconButton.styles");
var _LoadingButton = require("../../components/LoadingButton/LoadingButton.styles");
var _TextButton = require("../../components/TextButton/TextButton.styles");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var directionCSS = function directionCSS(props) {
  var conjoined = props.conjoined,
    direction = props.direction;
  var isColumn = ['column', 'column-reverse'].includes(direction);
  var alignDirection = isColumn || conjoined ? 'stretch' : 'start';
  return (0, _styledComponents.css)(["align-items:", ";flex-direction:", ";", ",", ",", ",", "{margin-top:", ";margin-left:", ";&:first-child{margin-top:0;margin-left:0;}}"], alignDirection, direction, _Button.StyledButton, _LoadingButton.StyledLoadingButton, _TextButton.StyledTextButton, _IconButton.StyledIconButton, isColumn ? (0, _spaceMixin.spaceMixin)('xs')(props) : 0, !isColumn ? (0, _spaceMixin.spaceMixin)('xs')(props) : 0);
};
var fluidCSS = function fluidCSS(props) {
  return (0, _styledComponents.css)(["", ",", ",", ",", "{flex-basis:", ";flex-grow:", ";}"], _Button.StyledButton, _LoadingButton.StyledLoadingButton, _TextButton.StyledTextButton, _IconButton.StyledIconButton, props.fluid ? '100%' : 'auto', props.fluid ? '1' : '0');
};
var conjoinedCSS = function conjoinedCSS(props) {
  var conjoined = props.conjoined,
    direction = props.direction;
  if (!conjoined) {
    return '';
  }
  var isColumn = ['column', 'column-reverse'].includes(direction);
  return (0, _styledToken.default)({
    marginLeft: 'Button.borderWidth',
    borderRadius: 'Button.borderRadius'
  }, function (_ref) {
    var marginLeft = _ref.marginLeft,
      borderRadius = _ref.borderRadius;
    return (0, _styledComponents.css)(["position:relative;z-index:1;", ",", ",", ",", "{margin-top:", ";margin-left:", ";border-radius:0;&:first-child{border-top-left-radius:", "px;", "}&:last-child{border-bottom-right-radius:", "px;", "}position:relative;z-index:1;&[aria-pressed='true']{z-index:2;}&:focus{z-index:3;}}"], _Button.StyledButton, _LoadingButton.StyledLoadingButton, _TextButton.StyledTextButton, _IconButton.StyledIconButton, isColumn ? "-" + marginLeft + "px" : 0, !isColumn ? "-" + marginLeft + "px" : 0, borderRadius, isColumn ? (0, _styledComponents.css)(["border-top-right-radius:", "px;border-bottom-left-radius:0;"], borderRadius) : (0, _styledComponents.css)(["border-bottom-left-radius:", "px;border-top-right-radius:0;"], borderRadius), borderRadius, isColumn ? (0, _styledComponents.css)(["border-bottom-left-radius:", "px;border-top-right-radius:0;"], borderRadius) : (0, _styledComponents.css)(["border-top-right-radius:", "px;border-bottom-left-radius:0;"], borderRadius));
  })(props);
};

/** @class ButtonGroupMixin */
/** @method */
var ButtonGroupMixin = function ButtonGroupMixin(props) {
  return (0, _styledToken.default)('Button.horizontalPadding', function (padding) {
    return (0, _styledComponents.css)(["display:flex;", "{text-align:center;align-self:stretch;padding-left:", "px;padding-right:", "px;}", " ", " ", " ", ""], _TextButton.StyledTextButton, padding, padding, (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('direction', directionCSS)(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('fluid', fluidCSS)(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('direction', conjoinedCSS)(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.ButtonGroupMixin = ButtonGroupMixin;